import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Drawer, Input, Form, AutoComplete, Radio, Checkbox } from 'kts-xui';
import { Tag, Space } from 'kts-components-antd-x4';
import { invite } from 'src/api';
import { create } from 'kts-scaffold-framework/utils/form';
// import { AutoComplete } from 'antd';
import debounce from 'lodash/debounce';
import { FormInstance } from 'kts-components-antd-x4/lib/form';
const Option = AutoComplete.Option;
const { CheckableTag } = Tag;
const FormItem = Form.Item;
import './index.less';
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onClose?: () => void;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    formRef = React.createRef<FormInstance>();
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            selectedTags: [],//被选中的tag标签
            purchaserTag: [],//客户标签
            supplierTag: [],//供应商标签
            radioVal: ['SUPPLIER']
        };
    }
    componentDidMount() {
        this.getCategories();
    }
    getCategories = async () => {
        const res: any = await invite.getCategory(this, {
            bizRoles: 'PURCHASER',
        });
        if (!res.er && res.res) {
            res.res = res.res.map((item, index) => {
                return {
                    ...item,
                    key: index
                };
            });
            
            this.setState({
                purchaserTag: res.res,
            });
        }
        const res2: any = await invite.getCategory(this, {
            bizRoles: 'SUPPLIER',
        });
        if (!res2.er && res2.res) {
           
            res2.res = res2.res.map((item, index) => {
                return {
                    ...item,
                    key: index + (res.res.length || 0)
                };
            });
            
            this.setState({
                supplierTag: res2.res,
                selectedTags: res2.res
            });
        }
    }
    onClose = () => {
        this.props.onClose();
    }
    onSubmit = () => {
        this.formRef.current.submit();
    }
    handleChange(tag: any, checked: boolean) {
        const { selectedTags, purchaserTag, supplierTag, radioVal } = this.state;
        const nextSelectedTags = checked ? [...selectedTags, tag] : selectedTags.filter(t => t.key !== tag.key);
        let strArray = [];

        const purchaserTagIds = purchaserTag.reduce((a, b) => {
            a.push(b.key);
            return a;
        }, []);
        const supplierTagIds = supplierTag.reduce((a, b) => {
            a.push(b.key);
            return a;
        }, []);
        console.log(supplierTagIds, purchaserTagIds);
        nextSelectedTags.forEach((item) => {
            if (supplierTagIds.includes(item.key)) {
                if (!strArray.includes('SUPPLIER')) {
                    strArray = strArray.concat(['SUPPLIER']);
                }

            } else {
                if (purchaserTagIds.includes(item.key)) {
                    if (!strArray.includes('PURCHASER')) {
                        strArray = strArray.concat(['PURCHASER']);
                    }
                }
            }
        }, []);
        
        this.setState({
            selectedTags: nextSelectedTags,
            radioVal: strArray
        });
        this.formRef.current.setFieldsValue({ bizRoles: strArray });
    }
    onRadioChange = (list) => {
        let tags = [];
        tags = list.includes('SUPPLIER') && tags.concat(this.state.supplierTag) || tags;
        tags = list.includes('PURCHASER') && tags.concat(this.state.purchaserTag) || tags;
        console.log(tags);
        this.setState({
            radioVal: list,
            selectedTags: tags
        });
    }
    render() {
        const { selectedTags, radioVal } = this.state;
        return (
            <div className="network asideroverall">
                <Drawer
                    title="邀请公司"
                    onClose={this.onClose}
                    visible={true}
                    footer={
                        <div style={{ textAlign: 'right' }} >
                            {this.modulesState.showLinkButtonDetail && <Button style={{ marginRight: 8 }} type="primary" onClick={this.onCreateRelation.bind(this, this.modulesState.showLinkButtonDetail)}>建立连接</Button>}
                            {!this.modulesState.showLinkButtonDetail && <Button style={{ marginRight: 8 }} key='1' type="primary" onClick={this.onSubmit}>邀请</Button>}
                            <Button key='2' onClick={this.onClose}>取消</Button>
                        </div>}
                >
                    <Form
                        layout='vertical'
                        ref={this.formRef}
                        labelCol={null}
                        wrapperCol={null}
                        onFinish={this.submitModal}
                    >
                        <FormItem
                            label='业务角色'
                            name='bizRoles'
                            rules={[{ required: true, message: "请勾选业务角色", }]}
                            initialValue={radioVal}
                            className='sm-radio'
                        >
                            <Checkbox.Group onChange={this.onRadioChange}>
                                <Space direction="vertical">
                                    <Checkbox value='SUPPLIER'>我的供应商
                                    </Checkbox>
                                    <div>
                                        {this.state.supplierTag.map(tag => (
                                            <CheckableTag
                                                key={tag.key}
                                                checked={selectedTags.findIndex(item => item.key === tag.key) >= 0 ? true : false}
                                                onChange={checked => this.handleChange(tag, checked)}
                                            >
                                                {tag.categoryName}
                                            </CheckableTag>
                                        ))}
                                    </div>
                                    <Checkbox value='PURCHASER'>我的客户/经销商
                                    </Checkbox>
                                    <div>
                                        {this.state.purchaserTag.map(tag => (
                                            <CheckableTag
                                                key={tag.key}
                                                checked={selectedTags.findIndex(item => item.key === tag.key) >= 0 ? true : false}
                                                onChange={checked => this.handleChange(tag, checked)}
                                            >
                                                {tag.categoryName}
                                            </CheckableTag>
                                        ))}
                                    </div>

                                </Space>
                            </Checkbox.Group>
                        </FormItem>
                        <FormItem
                            colon={false}
                            label="公司名称"
                            name="invitationCompanyName"
                            rules={[{ required: true, message: "请输入公司名称", }]}
                        >

                            <AutoComplete
                                // dataSource={this.modulesState.companyVagueData}
                                // onSearch={this.handleCompanyNameSearch}
                                onSelect={this.companySelect}
                                allowClear={true}
                                // onChange={this.changNameChange}
                                placeholder='请输入公司名称'
                                onSearch={debounce(this.changNameChange, 800)}
                            >
                                {this.modulesState.companyVagueData.map((item, index) => {
                                    return (
                                        <Option value={item.value} key={index}>
                                            {item.text}
                                        </Option>
                                    );
                                })}
                            </AutoComplete>
                        </FormItem>
                        {
                            !this.modulesState.showLinkButtonDetail &&
                            <FormItem colon={false} label="电子邮箱" name='invitationEmail' rules={[{ required: true, message: "请输入电子邮箱" }, { type: 'email', message: '请输入正确的电子邮箱!' }]}>
                                <Input type="text" placeholder='请输入电子邮箱' />
                            </FormItem>
                        }

                    </Form>
                </Drawer>
                {/* <div style={{ textAlign: 'center', marginBottom: '40px' }} className={css.uploadbatchcancel}>
                    {
                        this.modulesState.showLinkButtonDetail ?
                            <Button
                                type="primary"
                                className={`${css.canceluploadbatch} greenbtn`}
                                onClick={this.onCreateRelation.bind(this, this.modulesState.showLinkButtonDetail)}
                            >建立连接
                        </Button> :
                            <Button
                                type="primary"
                                className={`${css.canceluploadbatch} greenbtn`}
                                // htmlType="submit"
                                onClick={this.submitModal}
                            >邀请
                        </Button>
                    }
                    <Button className={`${css.canceluploadbatch} defaultbtn height46`} onClick={ModulesAction.hideAside}>取消</Button>
                </div> */}
            </div>
        );
    }
    private submitModal = (values) => {
        const data = {
            ...values,
            categories: this.state.selectedTags
        };
        ModulesAction.invitOneCompany(data);
        this.formRef.current.resetFields();

    }
    /** 被选中的公司 */
    private companySelect = (companyId) => {
        let _form = this.formRef.current;
        ModulesAction.networkCompayDetailSetForm(companyId, _form);
    }
    /** 模糊查询公司名称 */
    private handleCompanyNameSearch = (value) => {
        ModulesAction.clearShowLinkButtonDetail();
        // this.props.form.setFieldsValue({
        //     invitationEmail: ''
        // });
        if (value && value.trim()) {
            ModulesAction.companyNameSearch({ name: value });
        }
    }
    /** 发送连接请求 */
    private onCreateRelation = (rec) => {
        ModulesAction.sendRelation({
            targetCompanyId: rec.companyId,
            targetTaxId: rec.taxId
        });
        this.formRef.current.resetFields();
    }

    private changNameChange = async (value) => {
        ModulesAction.clearShowLinkButtonDetail();
        // this.props.form.setFieldsValue({
        //     invitationEmail: ''
        // });
        if (value && value.trim()) {
            ModulesAction.companyNameSearch({ name: value }).then(res => {
                if (!res.er) {
                    const companyVagueData = this.modulesState.companyVagueData;
                    const matchComapnyName = companyVagueData.filter(el => el.name === value);
                    if (matchComapnyName.length > 0) {
                        ModulesAction.updateShowLinkButtonDetail(matchComapnyName[0]);
                        this.formRef.current.setFieldsValue({ invitationCompanyName: matchComapnyName[0].name });
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Modal.Invitation.tsx